<template>
  <div id="the-file-uploader" class="the-file-uploader">
    <form class="the-file-uploader__container">
      <input
        type="file"
        id="the-file-uploader__container__file-elements"
        multiple
        accept="image/jpeg,image/png"
        @change="handleFiles"
      />
      <label
        class="the-file-uploader-items the-file-uploader-load"
        for="the-file-uploader__container__file-elements"
        title="Переместите файл внутрь зоны или нажмите для загрузки файлов"
      >
        <i class="el-icon-upload"></i>
        <div class="the-file-uploader-load_button"></div>
      </label>

      <div
        class="the-file-uploader-items"
        v-for="(file, index) in files"
        :key="index"
        :title="getFileTitle(file)"
        @click="selectedFile(index)"
      >
        <img
          class="the-file-uploader-items-image"
          :src="file.src"
          :alt="file.file.name"
        />
        <div class="the-file-uploader-items_size">
          {{ getFileDimensionName(file) }}
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "TheFileUploader",
  components: {},
  props: {},
  data() {
    return {
      dropArea: undefined,
      eventList: [
        {
          event: "dragenter",
          emits: [this.preventDefaults, this.highlight]
        },
        {
          event: "dragover",
          emits: [this.preventDefaults, this.highlight]
        },
        {
          event: "dragleave",
          emits: [this.preventDefaults, this.unhighlight]
        },
        {
          event: "drop",
          emits: [this.preventDefaults, this.unhighlight, this.handleDrop]
        }
      ]
    };
  },
  computed: {
    ...mapState({
      files: state => state.theFileUploader.files,
      indexSelectedFile: state => state.theFileUploader.indexSelectedFile
    })
  },
  methods: {
    ...mapActions(["uploadFilesToStorage"]),
    ...mapMutations(["selectFile"]),
    preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    highlight() {
      this.dropArea.classList.add("highlight");
    },
    unhighlight() {
      this.dropArea.classList.remove("highlight");
    },
    handleDrop(e) {
      let dt = e.dataTransfer;
      let files = dt.files;
      this.uploadFilesToStorage([...files]);
    },
    handleFiles(e) {
      if (e.target.files) {
        this.uploadFilesToStorage([...e.target.files]);
      }
    },
    setListener() {
      this.dropArea = document.getElementById("the-file-uploader");
      if (this.dropArea) {
        this.eventList.forEach(eventObj => {
          eventObj.emits.forEach(emit => {
            this.dropArea.addEventListener(eventObj.event, emit, false);
          });
        });
      }
    },
    removeListener() {
      if (this.dropArea) {
        this.eventList.forEach(eventObj => {
          eventObj.emits.forEach(emit => {
            this.dropArea.removeEventListener(eventObj.event, emit, false);
          });
        });
      }
    },
    selectedFile(index) {
      this.selectFile(index);
    },
    getSizeName(byte) {
      const units = ["b", "kb", "mb"];
      const bt = 1024;
      let sz = byte;
      let i = 0;
      while (sz > bt || i > units.length - 1) {
        sz /= bt;
        i++;
      }
      return `${sz.toFixed(2)}${units[i]}`;
    },
    getFileDimensionName(file) {
      const width = file.dimension.width;
      const height = file.dimension.height;
      return `${width}x${height}px`;
    },
    getFileTitle(file) {
      const name = file.file.name;
      const dimension = this.getFileDimensionName(file);
      const sizeName = this.getSizeName(file.file.size);
      return `${name}\n${dimension}\n${sizeName}`;
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.setListener();
    });
  },
  beforeDestroy() {
    this.removeListener();
    this.dropArea = undefined;
  }
};
</script>

<style lang="scss" scoped>
@import "./TheFileUploader.scss";

.the-file-uploader {
  width: 100%;
  box-sizing: border-box;
  border: $border_solid;
  border-radius: $border_radius;

  min-height: $min_height;

  .the-file-uploader__container {
    box-sizing: border-box;
    padding: $container_padding;
    height: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    /*display: flex;*/

    #the-file-uploader__container__file-elements {
      display: none;
    }

    .the-file-uploader-items {
      position: relative;
      height: 100%;
      width: 100px;
      margin-left: $indent_between_cards;
      cursor: pointer;
      display: inline-block;
      box-sizing: border-box;
    }

    .the-file-uploader-items:hover {
      border: $border_solid;
      border-radius: $border_radius;
      box-shadow: $shadow;
      background-color: $background_color;
    }

    .the-file-uploader-items-image {
      height: 80%;
      width: 100%;
    }

    .the-file-uploader-items_size {
      position: absolute;
      bottom: 1px;
      font-size: 12px;
      width: 100%;
      text-align: center;
    }

    .the-file-uploader-load {
      display: inline-block;
      margin-left: 0;
      vertical-align: top;

      .el-icon-upload {
        font-size: $loader_icon_font_size;
        color: $loader_icon_color;
        margin-top: 15%;
        margin-left: 20%;
        line-height: 50px;
      }

      .the-file-uploader-load_button {
        font-size: 12px;
      }
    }

    .the-file-uploader-items,
    .the-file-uploader-load {
      border: $border_solid;
    }
  }
}

.highlight {
  border: $border_highlight;
}

.the-file-uploader__container::-webkit-scrollbar {
  width: $scroll_size;
  height: $scroll_size;
}

.the-file-uploader__container::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px $scroll_track_color;
}

.the-file-uploader__container::-webkit-scrollbar-thumb {
  background-color: $loader_icon_color;
}

.the-file-uploader__container::-webkit-scrollbar-thumb:hover {
  background-color: $border_color;
}
</style>
